import React from 'react';

import MainUI2 from '../../components/main-ui-2-component/main-ui-2-component'

const Payment = () => (
  <div>
    <MainUI2 />
  </div>
);

export default Payment;